<template>
  <div id="main-panel" v-if="cartDataLoaded">

    <!-- <div>Order closed:{{cart.orderClosed}}</div> -->
    <div v-if="error == null">
      <!-- If the order is new or in progress -->
      <router-view />
    </div>
    <div v-if="error != null">
      {{error}}
    </div>
<!-- v-if="user.authenticated" -->
    <!-- <div @click="logout" style='padding-top: 400px; text-align: center' >LOGOUT</div> -->
    <div v-if="(cart.cartId || cart.cartTemporary)">

      <!-- If the Order is done -->
      <!-- <confirmation v-if="cart.data.orderNumber"
        :cart="cart.data"/> -->

    </div>

  </div>
</template>

<script>
import User from '@/service/user';
import Cart from '@/cart';

import Langs from '@/langs';

// import Confirmation from './Confirmation';

export default {
  name: 'Main',
  components: {
    // Confirmation
  },
  data () {
    return {
      cart: Cart,
      user: User,
      error: null,
      cartDataLoaded: false,
      cartId: Cart.cartId,
      cartState: Cart.data.processingState
    };
  },
  watch: {
    cartId: {
      deep: true,
      handler() {
        console.log('cartId changed')
        if (!this.cartDataLoaded) {
          this.$router.push({
            name: 'Order',
            params: {
              shopId: this.$route.params.shopId,
              cartId: Cart.cartId
            }
          })
        }
      }
    }
  },
  created() {
    console.log('created main', this.cart, this.cart.data.orderNumber)


    console.log('Main cart created', this.$route.params.shopId, this.$route.params.cartId)
    // User.checkLogin()

    if (this.$route.params.shopId && this.$route.params.cartId) {
      // if (this.$route.query.apiKey && this.$route.query.mode && this.$route.query.oobCode) {
      //   if (this.$route.query.em) {
      //     // For loging in at another device
      //     window.localStorage.setItem('emailForSignIn', this.$route.query.em);
      //   }
      //   console.log('User performing login')
      //   // The user is processing login
      //   User.loginWithFBLink(this.$route.query, this.$route.params)
      //   .then(result => {
      //     console.log('Logged in with Firebase', result)
      //     this.loadCart()
      //   })
      //   .catch(err => {
      //     console.error('Unable to login user', err)
      //   })
      // } else {
        this.loadCart()
      // }
    } else if (this.$route.params.shopId) {
      // At least the shop ID is provided, load the app... and wait for the cart
      console.log('Waiting...')
      this.cartDataLoaded = true
    } else {
      console.error('No cart identification.')
      this.error = Langs.get('NO_CART_ID')
    }
  },
  methods: {
    loadCart() {
      console.log('User loading the cart content.')
      // The user can proceed to cart content
      Cart.openCart(this.$route.params.shopId, this.$route.params.cartId)
      .then(done => {
        console.log("Done loading cart data")

        // user is trying to load a cart that was finalized and converted to order -> reset cart
        // this can happen when user finalizes order and doesn't click on 'shop again', then reloads window
        if (this.cart.orderClosed) {
          console.log('resetting cart')
          Cart.closeOrder(Cart.data.orderNumber)
          // Cart.resetCart()
          // this.loadCart()
        } else {
          this.cartDataLoaded = true
        }
      })
      .catch(err => {
        console.error('Error while loading cart data', err)
        // this.error = err.message
        this.cartDataLoaded = true
      })
    },
    logout() {
      User.logout()
    }
  }
}
</script>

<style>

</style>
